import { render, staticRenderFns } from "./ibcExamination_detail.vue?vue&type=template&id=86ebc01e&scoped=true&"
import script from "./ibcExamination_detail.vue?vue&type=script&lang=js&"
export * from "./ibcExamination_detail.vue?vue&type=script&lang=js&"
import style0 from "./ibcExamination_detail.vue?vue&type=style&index=0&id=86ebc01e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ebc01e",
  null
  
)

export default component.exports